import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider, useApp } from "./context/AppContext";
import { ThemeProvider } from "./styles/theme";
import AppLayout from "./layouts/AppLayout";
import LoadingScreen from "./components/LoadingScreen";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import DailyPL from "./pages/DailyPL";
import Purchases from "./pages/Purchases";
import Expenses from "./pages/Expenses";
import Sales from "./pages/Sales";
import Salaries from "./pages/Salaries";
import DebtManager from "./pages/DebtManager";
import Ledger from "./pages/Ledger";
import Settings from "./pages/Settings";

function RouterContent() {
  const { authLoading, authUser } = useApp();

  if (authLoading) return <LoadingScreen />;
  if (!authUser)   return <Auth />;

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard"    element={<Dashboard />} />
        <Route path="/daily-pl"     element={<DailyPL />} />
        <Route path="/purchases"    element={<Purchases />} />
        <Route path="/expenses"     element={<Expenses />} />
        <Route path="/sales"        element={<Sales />} />
        <Route path="/salaries"     element={<Salaries />} />
        <Route path="/debt-manager" element={<DebtManager />} />
        <Route path="/ledger"       element={<Ledger />} />
        <Route path="/settings"     element={<Settings />} />
        <Route path="*"             element={<Navigate to="/dashboard" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AppProvider>
        <BrowserRouter>
          <RouterContent />
        </BrowserRouter>
      </AppProvider>
    </ThemeProvider>
  );
}
